import React from 'react'
import { useDocumentTitle } from '../../common/useDocumentTitle'

import { Col, Container, Row, Tab } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { Tabs } from '../../components/Tabs/Tabs'
import { IntegrationDirectory } from './IntegrationDirectory'
import { OAuth2AppDirectory } from '../OAuth2App/OAuth2AppDirectory'
import { useIsFeatureAdvertisementEnabled } from '../../common/useIsFeatureAdvertisementEnabled'
import { useRedirectHiddenTab } from '../../common/useRedirectHiddenTab'
import { useCustomIntegrationQuota } from '../CustomIntegration/useCustomIntegrationQuota'
import { McpPromoBanners } from '../Growth/McpPromo/McpPromoBanners'
import { McpPromoPage } from '../Growth/McpPromo/mcpPromoConfig'

const VALID_SECTIONS = ['integrations', 'oauth2apps'] as const
type Section = (typeof VALID_SECTIONS)[number]

interface TabTitleProps {
  title: string
}

const TabTitle: React.FC<TabTitleProps> = ({ title }) => <div className='d-flex align-items-center'>{title}</div>

export const IntegrationSettings: React.FC = () => {
  const navigate = useNavigate()
  useDocumentTitle('Integrations')
  const { section: rawSection } = useParams()
  const section: Section = typeof rawSection === 'string' && VALID_SECTIONS.includes(rawSection as Section) ? (rawSection as Section) : 'integrations'
  const { oauth2AppsEnabled, customIntegrationsEnabled } = useCustomIntegrationQuota()
  const { isEnabled: isOAuth2AppDirectoryTabVisible, isFetching: isFeatureAdvertisementFetching } = useIsFeatureAdvertisementEnabled({
    bypass: oauth2AppsEnabled || customIntegrationsEnabled,
  })

  const changeTab = (key: string | null) => {
    if (key) {
      navigate(`/account/integration-settings/${key}`, { replace: true })
    }
  }

  useRedirectHiddenTab({
    currentKey: section,
    hiddenKeys: [!isOAuth2AppDirectoryTabVisible && 'oauth2apps'],
    isLoading: isFeatureAdvertisementFetching,
    fallbackPath: '/account/integration-settings/integrations',
  })

  return (
    <div className='full-size-content'>
      <Container fluid>
        <Row className='mb-5'>
          <Row className='mb-2'>
            <Col className='p-0'>
              <h3>Integrations</h3>
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col className='p-0'>Connect the tools you and your team use every day</Col>
          </Row>
        </Row>

        <Row className='mb-5'>
          <Col className='p-0'>
            <McpPromoBanners page={McpPromoPage.INTEGRATION_SETTINGS} />
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Tabs className='mb-6' defaultActiveKey={section} onSelect={changeTab} id='integration-settings-tabs' activeKey={section}>
              <Tab className='mt-2' eventKey='integrations' title={<TabTitle title='Integrations' />}>
                <IntegrationDirectory />
              </Tab>
              {isOAuth2AppDirectoryTabVisible && (
                <Tab className='mt-2' eventKey='oauth2apps' title={<TabTitle title='Apps' />}>
                  <OAuth2AppDirectory />
                </Tab>
              )}
            </Tabs>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
